<div class="flex flex-column flex-wrap align-content-center align-items-center my-auto gap-3">
    <h3 class="mt-5">Gracias por registrarte</h3>
    <p *ngIf="!longMessage">Escríbenos para completar el registro</p>
    <p *ngIf="longMessage">Comunícate para realizar tu verificación de mayoría de edad y activar tu anuncio</p>
    <button pButton label="{{ registrationNumber }}" (click)="contact()" icon="pi pi-whatsapp" class="whatsapp" [disabled]="isNumberEmpty"></button>
    <p-button label="Volver al inicio" (click)="goHome()"></p-button>
</div>